import React from "react";
import {
  Box, Tooltip, Typography,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

type Props = {
  title: string,
  description: string,
}

function Title({
  title,
  description,
}: Props) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        minHeight: "26px",
        paddingBottom: "4px",
        boxSizing: "border-box",
      }}
    >
      <Box display="flex">
        <Box pr={1}>
          <Tooltip title={description}>
            <HelpOutlineIcon />
          </Tooltip>
        </Box>
        <Typography sx={{ wordBreak: "break-all" }}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
}

export default Title;
